var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React from 'react';
import { Button, GBTypography } from '@leapfinance/geebee-component-library';
import { KeyboardArrowDown, KeyboardArrowUp } from '@mui/icons-material';
import { Popover } from '@mui/material';
import DownloadExcelIcon from '../../geebee/icons/course-details-page/DownloadExcel';
import DownloadPdfIcon from '../../geebee/icons/course-details-page/DownloadPdf';
var CoursesDownloadButtons = function (_a) {
    var courses = _a.courses, className = _a.className, pdfDownloadButtonProps = _a.pdfDownloadButtonProps, excelDownloadButtonProps = _a.excelDownloadButtonProps, onDownloadClick = _a.onDownloadClick, onCsvDownload = _a.onCsvDownload, onPdfDownload = _a.onPdfDownload;
    var handlePdfDownload = function () {
        onDownloadClick();
        // coursesPdfDownloader(courses);
        onPdfDownload(courses);
    };
    var handleExcelDownload = function () {
        onDownloadClick();
        // generateCourseExcel(courses, 'course-data');
        onCsvDownload(courses, 'course-data');
    };
    return (React.createElement("div", { className: className !== null && className !== void 0 ? className : 'lfc-p-3 lfc-flex lfc-flex-col lfc-gap-y-1' },
        React.createElement(Button, __assign({ variant: "secondary", size: "small", className: "lfc-py-1 lfc-px-2 lfc-rounded lfc-border lfc-border-grey-200 lfc-bg-white lfc-flex lfc-gap-2" }, pdfDownloadButtonProps, { onClick: handlePdfDownload }),
            React.createElement(DownloadPdfIcon, null),
            React.createElement(GBTypography, { variant: "cta5", className: "lfc-text-black lfc-normal-case" }, "Download PDF")),
        React.createElement(Button, __assign({ size: "small", variant: "secondary", className: "lfc-py-1 lfc-px-2 lfc-rounded lfc-border lfc-border-grey-200 lfc-bg-white lfc-flex lfc-gap-2" }, excelDownloadButtonProps, { onClick: handleExcelDownload }),
            React.createElement(DownloadExcelIcon, null),
            React.createElement(GBTypography, { variant: "cta5", className: "lfc-text-black lfc-normal-case" }, "Download Excel"))));
};
var CoursesDownloadButtonSection = function (_a) {
    var courses = _a.courses, onCsvDownload = _a.onCsvDownload, onPdfDownload = _a.onPdfDownload;
    var _b = __read(React.useState(null), 2), anchorEl = _b[0], setAnchorEl = _b[1];
    var handleClick = function (event) {
        setAnchorEl(event.currentTarget);
    };
    var handleClose = function () {
        setAnchorEl(null);
    };
    var open = Boolean(anchorEl);
    var id = open ? 'simple-popover' : undefined;
    return (React.createElement("div", { className: "lfc-w-full" },
        React.createElement(Button, { variant: "secondary", size: "small", className: "lfc-bg-white lfc-rounded lfc-border lfc-border-black lfc-normal-case lfc-px-2 lfc-py-[0.38rem] lfc-w-full", onClick: handleClick },
            React.createElement(GBTypography, { variant: "cta5", className: "lfc-text-black" }, "Download"),
            open ? (React.createElement(KeyboardArrowUp, { className: "lfc-w-4 lfc-h-4 lfc-text-black" })) : (React.createElement(KeyboardArrowDown, { className: "lfc-w-4 lfc-h-4 lfc-text-black" }))),
        React.createElement(Popover, { id: id, open: open, anchorEl: anchorEl, onClose: handleClose, anchorOrigin: {
                vertical: -90,
                horizontal: 'left'
            } },
            React.createElement(CoursesDownloadButtons, { courses: courses, onDownloadClick: function () {
                    handleClose();
                }, onPdfDownload: onPdfDownload, onCsvDownload: onCsvDownload }))));
};
export default CoursesDownloadButtonSection;
//# sourceMappingURL=CoursesDownloadButtonSection.js.map